'use client'
import useFlightTimingFilterManager from '@/src/hooks/srp/flightTimingFilterManager'
import { useMulticitySectionJourneyIndex } from '../multicityFilterJourneyScope'
import { FlightTimingsFilter } from './FlightTimingsFilter'

const FlightTimingsFilterWrapper = () => {
    const filterJourneyIndex = useMulticitySectionJourneyIndex(0)
    const { timeSlots, handleSelectToggle, handleReset, handleResetAllJourneys, shouldShowReset, shouldShowResetForAllJourneys, isMulticity, title, hideBottomDivider } =
        useFlightTimingFilterManager(filterJourneyIndex)

    return (
        <FlightTimingsFilter
            flightTimings={timeSlots}
            onTimeSlotSelect={handleSelectToggle}
            onReset={isMulticity ? handleResetAllJourneys : handleReset}
            shouldShowReset={isMulticity ? shouldShowResetForAllJourneys : shouldShowReset}
            title={title}
            hideBottomDivider={hideBottomDivider}
        />
    )
}

export { FlightTimingsFilterWrapper as FlightTimingsFilter }

export default FlightTimingsFilterWrapper
